export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/bootcamp/activities/long-multi/comma-dashed.svg'
